import { ActionContext, ActionTree } from "vuex";
import { StatusCodes } from "http-status-codes";
import ChurningService from "@/modules/Churning/services/churningBookings.service";
import { ChurningQueryPayload } from "@/modules/Churning/constants";
import { IChurningState } from "@/modules/Churning/vuex/state";
import { StoreState } from "@/store/type";
import notificationService from "@/core/services/notification.service";
import { NOTIFICATION_TYPES } from "@/core/enums/NOTIFICATION_TYPES";

const churningService = new ChurningService();

const actions: ActionTree<IChurningState, StoreState> = {
  async fetchChurning(
    context: ActionContext<IChurningState, StoreState>,
    payload: ChurningQueryPayload,
  ) {
    try {
      context.commit("setChurningLoading", true);
      context.commit("setChurningError", null);

      const response = await churningService.fetchChurning(payload);
      const { success, status, data } = response.data;

      if (success && status === StatusCodes.OK) {
        context.commit("setChurningData", data);

        return response;
      }

      throw response;
    } catch (error) {
      const errorMessage = (error as Error).message;
      context.commit("setChurningError", errorMessage);
      notificationService.type = NOTIFICATION_TYPES.ERROR;
      notificationService.description = errorMessage;
      notificationService.triggerNotification();
      return error;
    } finally {
      context.commit("setChurningLoading", false);
    }
  },
  resetChurning(context: ActionContext<IChurningState, StoreState>) {
    context.commit("resetChurningState");
  },
};

export default actions;
